if (!customElements.get('marketing-form')) {
  customElements.define(
    'marketing-form',
    class MarketingForm extends HTMLElement {
      constructor() {
        super();

        /** @type {HTMLFormElement | null} */
        this.form = this.querySelector('form');
        this.errors = this.querySelector('.marketing-form-errors');
        this.success = this.querySelector('.marketing-form-success');

        /** @type {string | undefined} */
        this.companyId = this.dataset.klaviyoCompanyId;
        /** @type {string | undefined} */
        this.listId = this.dataset.klaviyoMarketingListId;
      }

      connectedCallback() {
        if (this.form) {
          this.form.addEventListener('submit', this.submitHandler.bind(this));
        }
      }

      /**
       * @param {Event} e - The form submit event
       * @returns {Promise<any>} - The response from the server
       */
      async submitHandler(e) {
        e.preventDefault();

        if (!this.form) return;
        if (this.form.dataset.loading === 'true') return;

        this.form.dataset.loading = 'true';

        this.hideErrors();
        this.hideSuccess();

        try {
          /** @type {any} */
          const formElements = this.form.elements;
          const formData = {
            email: formElements['email'].value.trim(),
          };

          if (!formData.email) {
            throw new Error('Please fill in all required fields');
          }

          await this.sendToKlaviyo(formData.email, this.form.id);

          if (this.success && this.success instanceof HTMLElement) {
            this.success.style.display = 'block';
          }

          this.form.dataset.loading = 'false';
        } catch (/** @type {any} */ error) {
          this.showErrors([error.message]);

          this.form.dataset.loading = 'false';
        }
      }

      /**
       * @param {string} email - The email to send to Klaviyo
       * @param {string} id - The form ID
       * @returns {Promise<void>} - A promise that resolves when the request is complete
       */
      async sendToKlaviyo(email, id) {
        if (!this.companyId || !this.listId) {
          throw new Error('Klaviyo is not configured correctly');
        }

        const payload = {
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    subscriptions: {
                      email: {
                        marketing: {
                          consent: 'SUBSCRIBED',
                        },
                      },
                    },
                  },
                },
              },
              custom_source: id,
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: this.listId,
                },
              },
            },
          },
        };

        const response = await fetch(
          `https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(this.companyId)}`,
          {
            method: 'POST',
            headers: {
              Accept: 'application/vnd.api+json',
              Revision: '2025-01-15',
              'Content-Type': 'application/vnd.api+json',
            },
            body: JSON.stringify(payload),
          },
        );

        if (!response.ok) {
          throw new Error('Something went wrong. Please try again later.');
        }
      }

      /** @param {string[]} errors - The errors to display */
      showErrors(errors) {
        const errorContainer = this.errors;

        if (!errorContainer || !(errorContainer instanceof HTMLElement)) return;

        errorContainer.innerHTML = errors.map((/** @type {string} */ error) => `<li>${error}</li>`).join('');
        errorContainer.style.display = 'block';
      }

      hideErrors() {
        const errorContainer = this.errors;

        if (!errorContainer || !(errorContainer instanceof HTMLElement)) return;

        errorContainer.style.display = 'none';
      }

      hideSuccess() {
        const successContainer = this.success;

        if (!successContainer || !(successContainer instanceof HTMLElement)) return;

        successContainer.style.display = 'none';
      }
    },
  );
}
